import { useEffect, useRef } from 'react';

interface TriStateCheckboxProps {
  checked: boolean;
  indeterminate: boolean;
  onChange: () => void;
  disabled?: boolean;
  title?: string;
  className?: string;
}

/**
 * Bare tri-state checkbox. The `indeterminate` (`–`) state can only be set on the
 * DOM element, not via a prop, so it's applied through a ref. `onChange` carries no
 * boolean — the caller decides the action from the current state, which suits
 * Gmail-style select-all controls where both the checked and indeterminate states
 * clear on click.
 */
export function TriStateCheckbox({
  checked,
  indeterminate,
  onChange,
  disabled = false,
  title,
  className = '',
}: TriStateCheckboxProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      title={title}
      onChange={(e) => {
        e.stopPropagation();
        onChange();
      }}
      className={`h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer shrink-0 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    />
  );
}
